import { query } from '@confluence/query-preloader-tools';
import { getAGGClient } from '@confluence/graphql';

import { PreloadNotificationCountQuery } from './preloadNotificationCountQuery.graphql';

export const preloadUnseenNotificationCount = () => {
	return query({
		query: PreloadNotificationCountQuery,
		client: getAGGClient(),
	});
};
